export default __webpack_public_path__ + "static/media/blogpost.24f5e773.gif";